import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

export const ContactSaleBtn = (
  { message, fullWidth, className, sx }: {
    message?: string;
    fullWidth?: boolean;
    className?: string;
    sx?: SxProps<Theme>;
  },
) => (
  <Button
    variant="outlined"
    component={RouterLink}
    className={className}
    to="https://katalon.com/contact-us#contact-us"
    target="_blank"
    size="small"
    sx={sx ?? ({
      color: '#5959EB',
      width: fullWidth ? '100%' : 160,
      borderColor: '#5959EB',
      '&:hover': {
        borderColor: '#43509B',
      },
    })}
  >
    {message ?? (
      <FormattedMessage
        id="page.subscription.current.subscription.manage.contact.sales"
      />
    )}
  </Button>
);
